import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import type { RestaurantFormData } from "@/types/restaurantForm";

interface UseRestaurantSubmissionProps {
  onSuccess?: () => void;
}

export const useRestaurantSubmission = ({ onSuccess }: UseRestaurantSubmissionProps = {}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: RestaurantFormData) => {
    setIsSubmitting(true);
    console.log('useRestaurantSubmission - Starting submission with data:', {
      ...data,
      latitude: data.latitude,
      longitude: data.longitude
    });

    try {
      const { error } = await supabase
        .from('restaurants')
        .insert({
          name: data.name,
          address: data.address,
          neighborhood_id: data.neighborhood_id,
          contact_email: data.contact_email,
          website: data.website,
          phone: data.phone,
          description: data.description,
          latitude: data.latitude,
          longitude: data.longitude
        });

      if (error) throw error;

      console.log('useRestaurantSubmission - Submission successful');
      toast.success("Restaurant submitted successfully");
      onSuccess?.();
    } catch (error) {
      console.error('Error submitting restaurant:', error);
      toast.error("Failed to submit restaurant");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    handleSubmit,
    isSubmitting
  };
};